
const ContactInfoSection = () => {
  return (
    <section className="py-20 bg-soft-gray">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="font-playfair text-3xl font-bold text-navy mb-6">
              Prefer to Talk Directly?
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Sometimes the best conversations happen over the phone. If you'd rather speak directly with Brian about your business and explore your options, we'd be happy to schedule a confidential call at your convenience.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#C9A227] rounded-lg flex-shrink-0">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-navy mb-2">Email</h3>
                  <p className="text-gray-600">brian@legacybusinessacq.com</p>
                  <p className="text-sm text-gray-500 mt-1">Direct contact with our founder</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#C9A227] rounded-lg flex-shrink-0">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-navy mb-2">Service Area</h3>
                  <p className="text-gray-600">Based in the Carolinas, acquiring businesses across the U.S.</p>
                  <p className="text-sm text-gray-500 mt-1">Focused on established, locally rooted companies.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#C9A227] rounded-lg flex-shrink-0">
                  <i className="ri-time-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-navy mb-2">Response Time</h3>
                  <p className="text-gray-600">Within 24 hours</p>
                  <p className="text-sm text-gray-500 mt-1">We respect your time and respond promptly</p>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <button 
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                className="btn-primary text-lg px-8 py-4"
              >
                Schedule a Confidential Call
              </button>
            </div>
          </div>

          <div className="relative">
            <img
              src="https://static.readdy.ai/image/2a3205e7e8ef8b3d476f9ddb9e8c5218/dc1235d9cb837b3cb2691924e019c309.png"
              alt="Diverse business professionals in consultation"
              className="rounded-lg shadow-lg w-full h-96 object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy/20 to-transparent rounded-lg"></div>
          </div>
        </div>

        <div className="mt-16 bg-navy rounded-lg p-8 text-center">
          <h3 className="font-playfair text-2xl font-semibold text-white mb-4">
            Schedule a Confidential Conversation Today
          </h3>
          <p className="text-gray-200 leading-relaxed max-w-3xl mx-auto mb-6">
            Every business owner's situation is unique. Let's discuss yours in a no-pressure, confidential conversation where you can ask questions, share your concerns, and explore your options.
          </p>
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="btn-primary"
          >
            Get Started
          </button>
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection;
